import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { useNavigate } from 'react-router-dom';
import BrokersImg from 'Assets/Images/brokers.png'
const MarketMakers = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');;
        }
    }, [currentLang, navigate]);
    const content = {
        fa: {
            description: (
                <>
                    در این قسمت می‌توانید <strong className="fw-bold">لیست بازارگردان‌های بورس انرژی ایران</strong> را به همراه موارد زیر مشاهده‌کنید:
                </>
            ),
            list: [
                "نام نماد",
                "نام بازارگردان",
                "عامل بازارگردان",
                "حداقل سفارش انباشته",
                "حداقل معاملات روزانه",
                "دوره زمانی بازارگردانی",
                "تاریخ آغاز، اتمام و سررسید",
                "وضعیت"
            ],
        },

        en: {
            description: (
                <>
                    In this section, you can view the <strong className="fw-bold">list of market makers of the Iran Energy Exchange</strong> along with the following details:
                </>
            ),
            list: [
                "Symbol Name",
                "Market Maker Name",
                "Market Maker Agent",
                "Minimum Accumulated Order",
                "Minimum Daily Trading",
                "Market Making Period",
                "Start, End, and Maturity Date",
                "Status"
            ],
        },

        ar: {
            description: (
                <>
                    في هذا القسم، يمكنك الاطلاع على <strong className="fw-bold">قائمة صناع السوق في بورصة الطاقة الإيرانية</strong> بالإضافة إلى التفاصيل التالية:
                </>
            ),
            list: [
                "اسم الرمز",
                "اسم صانع السوق",
                "وكيل صانع السوق",
                "الحد الأدنى للطلب المتراكم",
                "الحد الأدنى للتداول اليومي",
                "فترة صناعة السوق",
                "تاريخ البدء والانتهاء والاستحقاق",
                "الحالة"
            ],
        },
    };

    const { description, list } = content[currentLang] || content.fa; // fallback to fa

    return (
        <div className="megaMenuContent">
            <div className="row">
                <div className="col-12">
                    <div className="row justify-content-between h-100">
                        <div className="col-6">
                            <p className="text-nowrap">{description}</p>
                            <ul className="IeeStatuteList">
                                {list.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>

                        </div>
                        <div className="col-12 text-start mt-2 d-flex align-self-end justify-content-end">
                            <a href="/Market/MarketMakers" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                                {t("view_list")}
                                <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                    {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                                </span>
                            </a>

                        </div>
                    </div>
                </div>
                {/*<div className="col-6">*/}
                {/*    <img src={BrokersImg} className="w-100" />*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default MarketMakers;
